module.exports = __webpack_public_path__ + "static/background-top-center-sm-e23e2807613e2b3c63bea3cea4562bea.svg";